import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getHomeDashboardPath } from "../../../utils/dashboardRoutes";
import { hasSessionToken } from "../../../utils/authSession";

/**
 * Restricts /admin/* to authenticated users with user_type === "admin"
 * and a present JWT. Profile-only localStorage is not enough — blog/admin
 * APIs verify the token cryptographically.
 */
export function AdminRouteGuard({ children }) {
  const userData = useSelector((state) => state.auth.userData);
  const user = userData?.user;

  if (!user || !hasSessionToken(userData)) {
    return <Navigate to="/admin/login" replace />;
  }

  if (String(user.user_type || "").toLowerCase() !== "admin") {
    return <Navigate to={getHomeDashboardPath(user)} replace />;
  }

  return <>{children}</>;
}
